import axios from "axios";
import AddPaymentDataInFirebase from "../Firebase/Payment/AddPaymentDataInFirebase";
import { PurchaseSubscriptionMailAPI } from "../../MailAPIs/PurchaseSubscriptionMailAPI";
import GetPaymentData from "../Firebase/Payment/GetPaymentData";
import { logEvent } from '../../helper/shakebug';
import { trackPaymentSuccess } from '../../Utils/EventTracker';

export const HandlePaymentSuccess = async (response, state, dispatch, navigate) => {
    const {
        razorpay_payment_id,
        razorpay_subscription_id,
        razorpay_signature,
    } = response;

    try {

        // Delay the API call to fetch subscription details
        setTimeout(async () => {
            const apiUrl = `${process.env.REACT_APP_BASE_URL}get-subscription`;

            const res = await axios.post(apiUrl, {
                sub_id: razorpay_subscription_id,
            });
            console.log("response dataa", res)

            if (res.data) {

                let planName = null;

                // Define your plan logic here
                if (res?.data?.plan_id === process.env.REACT_APP_STARTER_PLANID_INR || res?.data?.plan_id === process.env.REACT_APP_STARTER_PLANID_USD) {
                    planName = "Starter Plan"
                } else if (res?.data?.plan_id === process.env.REACT_APP_PROFESSIONAL_PLANID_INR || res?.data?.plan_id === process.env.REACT_APP_PROFESSIONAL_PLANID_USD) {
                    planName = "Professional Plan"
                } else if (res?.data?.plan_id === process.env.REACT_APP_AGENCY_PLANID_INR || res?.data?.plan_id == process.env.REACT_APP_AGENCY_PLANID_USD) {
                    planName = "Agency Plan"
                } else {
                    planName = null
                }

                const payment_data = {
                    premiumLastDate: res?.data?.current_end,
                    subscriptionId: res?.data?.id,
                    paymentDate: res?.data?.current_start,
                    planName: planName
                }
                PurchaseSubscriptionMailAPI(state?.SET_USER?.email, state?.SET_USER?.name, payment_data?.planName, new Date(payment_data?.premiumLastDate * 1000)?.toLocaleDateString())

                // GA4: purchase event
                const currency = (res?.data?.plan_id === process.env.REACT_APP_STARTER_PLANID_USD ||
                    res?.data?.plan_id === process.env.REACT_APP_PROFESSIONAL_PLANID_USD ||
                    res?.data?.plan_id === process.env.REACT_APP_AGENCY_PLANID_USD) ? 'USD' : 'INR';
                trackPaymentSuccess(
                    planName,
                    razorpay_subscription_id,
                    razorpay_payment_id,
                    currency,
                    res?.data?.amount ? res.data.amount / 100 : 0,
                    state?.USERID
                );

                await GetPaymentData(state, dispatch);
                navigate("/success", {
                    state: {
                        subscriptionId: res?.data?.id,
                        planName: planName,
                        planId: res?.data?.plan_id,
                        currency: state?.SET_USER?.currency === "USD" ? "USD" : "INR"
                    }
                });
                // AddPaymentDataInFirebase(state, dispatch, state?.SET_USER?.referredBy);
            } else {
                console.error("No subscription details found.");
            }
        }, 10000); // 10 seconds delay for fetching subscription details
    } catch (error) {
        console.error("Error fetching subscription details:", error);
    }
};